import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {ReportsView} from "../views/reports";

export class ReportsFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new ReportsView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/reports`;
    }
}
